module.exports = __webpack_public_path__ + "img/sec1_b_m.bb39c549.png";